import { render, staticRenderFns } from "./knowledgeEntry.vue?vue&type=template&id=3a21fa79&scoped=true"
import script from "./knowledgeEntry.vue?vue&type=script&lang=js"
export * from "./knowledgeEntry.vue?vue&type=script&lang=js"
import style0 from "./knowledgeEntry.vue?vue&type=style&index=0&id=3a21fa79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21fa79",
  null
  
)

export default component.exports